var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57528 11.8505L14.5338 21.8052C14.6984 21.9743 14.9698 21.9743 15.1344 21.8052L16.3448 20.5998C16.5094 20.4307 16.5094 20.1595 16.3448 19.9949L7.89471 11.5482L16.3448 3.1014C16.5094 2.93681 16.5094 2.66536 16.3448 2.50077L15.1344 1.29111C14.9698 1.12652 14.6984 1.12652 14.5338 1.29111L4.57528 11.2456C4.40183 11.4147 4.40183 11.6816 4.57528 11.8505Z",
    fill: "#175BCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6ce0d66ead168e9a164088bbf18e034b.svg";
export { ForwardRef as ReactComponent };